import request from '@/http/request'

export const getCGradeList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/c/query`, params)
}
export const getCGradeImagesList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/c/pictory/query`, params)
}
export const getAbnormalLogList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/abnormal-package/log/query`, params)
}
export const cGradeExport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/c/export`, params)
}
export const getFactoryGroup = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/c/factory/group`, params)
}
export const getFactoryCode = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/c/factory/code`, params)
}
export const getFactoryGroupMco = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/c/mco`, params)
}
export const getSeasonList = () => {
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/c/sales/order/season/list`)
}

export const downloadImg = url => {
  return request.get(`${url}`, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
